export const ENTITY_PHASE_ITEM_STATUS_ICON_COLOR =
  'var(--entity-phase-item-color)'
